/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useAllGoals } from "./useAllGoals";
import primaryComponents, {
  MultiSelectFilter,
} from "../../../../../components/primaryComponents";
import { PlusIcon } from "../../../../../assets/svgIcons";
import {
  GoalsForm,
  GoalsTable,
} from "../../../../../components/secondaryComponents/Goals";
import { RoutedModal } from "../../../../../components/common";

export const AllGoals = () => {
  const {
    search,
    goalsStatus,
    isLoadingGoals,
    goalsList,
    metaDetails,
    storeList,
    isGoalsForm,
    setIsGoalsForm,
    filterByKey,
    gotoPage,
    filterBySearch,
    filterByDate,
  } = useAllGoals();
  const outcomeList = [
    {
      name: "On Track",
      id: "on_track",
    },
    {
      name: "Not Started",
      id: "not_started",
    },
    {
      name: "At Risk",
      id: "at_risk",
    },
    {
      name: "Off Track",
      id: "off_track",
    },
    {
      name: "Achieved",
      id: "achieved",
    },
    {
      name: "Missed",
      id: "missed",
    },
  ];

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Performance - Goals"
      description="View all goals set for a given duration"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles?.pageColumnGaps}`}
        >
          <div>
            <h4>Goals</h4>
            <p>
              Set achievable targets that will help drive the performance of
              your business.
            </p>
          </div>

          <div className={globalStyles.rowNavigations}>
            {goalsStatus?.map((item, index) => (
              <a
                key={index}
                className={`${globalStyles.rowNavigations__item} ${
                  search.get("status") === item?.value
                    ? globalStyles.active
                    : ""
                }`}
                onClick={() => filterByKey("status", item?.value)}
              >
                {item?.label}
              </a>
            ))}
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total} Revenue Goals</p>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey={"can_create_update_revenue_goal"}
            >
              <primaryComponents.Button
                classNames={"btn btn--primary"}
                onClick={() => setIsGoalsForm(true)}
              >
                <PlusIcon className="mr-1" /> Add New Goal
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          <div className={globalStyles.tableWrapper}>
            <div className={globalStyles.tableHeader}>
              <primaryComponents.SearchField
                classNames={globalStyles.searchField}
                placeholder="Search by goal name"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") !== null ? search.get("query") : ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />
              <div className="ml-auto" style={{ width: "200px" }}>
                <MultiSelectFilter
                  placeholder={"Select store"}
                  options={[...storeList]}
                  nameKey={"name"}
                  idKey={"id"}
                  selectedOption={
                    search.get("store_ids")
                      ? decodeURIComponent(search.get("store_ids")).split("|")
                      : []
                  }
                  onChange={(values) => {
                    const newValues = values?.join("|") || null;
                    filterByKey("store_ids", newValues);
                  }}
                />
              </div>
              <div style={{ width: "200px" }}>
                <primaryComponents.SelectField
                  options={[
                    {
                      name: "All outcomes",
                      id: null,
                    },
                    ...outcomeList,
                  ]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByKey("outcome", value);
                  }}
                  value={
                    outcomeList?.find(
                      (store) => `${store?.id}` === `${search.get("store_id")}`,
                    )?.name || "Filter outcome"
                  }
                  floatError={false}
                />
              </div>
              <primaryComponents.DateRangeInput
                startDate={search.get("start_date")}
                endDate={search.get("end_date")}
                onChange={filterByDate}
                showPlaceholder={true}
                classNames=""
              />
            </div>

            <secondaryComponents.LoaderHelper
              isLoading={isLoadingGoals}
              classNames={"mt-5"}
            >
              <GoalsTable
                goalsList={goalsList}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>

        <RoutedModal
          isActive={isGoalsForm}
          closeModal={() => {
            setIsGoalsForm(false);
          }}
          width={1000}
          headerTitle={"Add New Goal"}
          headerDescription="Create a revenue target for a specific store."
        >
          <GoalsForm
            closeModal={() => {
              setIsGoalsForm(false);
            }}
          />
        </RoutedModal>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
